// src/components/Billing/ContentfulPricingSection.Style.js
// @flow

const contentfulPricingSectionStyles = {
  container: (theme) => ({
    marginTop: theme.spacing(6),
    minHeight: 'calc(100vh - 600px)',
    display: 'flex',
    textAlign: 'center',
    '& a:hover': {
      textDecoration: 'none'
    }
  }),
  noHeight: (theme) => ({
    minHeight: 'auto'
  }),
  h1: (theme) => ({
    ...theme.typography.h1,
    color: theme.palette.custom.neoViolet.main,
    marginTop: theme.spacing(6),
    fontSize: '3.3rem',
    fontWeight: 800,
    lineHeight: 1.1,
    marginBottom: theme.spacing(2),
    fontFamily: ['Product Sans', 'sans-serif'].join(','),
    whiteSpace: 'pre-wrap',
    [theme.breakpoints.down('md')]: {
      fontSize: '3rem'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.6rem'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '2.3rem',
      lineHeight: 1.1,
      textAlign: 'center'
    }
  }),
  h2: (theme) => ({
    ...theme.typography.h2,
    fontSize: '2.4rem',
    fontWeight: 700,
    lineHeight: 1.2,
    color: theme.palette.custom.neoViolet.main,
    marginBottom: theme.spacing(1),
    fontFamily: ['Product Sans', 'sans-serif'].join(','),
    whiteSpace: 'pre-wrap',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.2rem',
      lineHeight: 1.3
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '2rem',
      lineHeight: 1.3,
      textAlign: 'center'
    }
  }),
  h3: (theme) => ({
    ...theme.typography.h3,
    fontSize: '1.6rem',
    fontWeight: 700,
    fontFamily: ['Product Sans', 'sans-serif'].join(','),
    whiteSpace: 'pre-wrap',
    lineHeight: 1.4,
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.6rem',
      lineHeight: 1.3,
      textAlign: 'center'
    }
  }),
  h5: (theme) => ({
    fontWeight: 600,
    fontSize: '1.1rem',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1)
  }),
  smallh5: (theme) => ({
    fontWeight: 400,
    fontSize: '1.1rem',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }),
  yearlyToggle: (theme) => ({
    margin: '0 auto',
    marginBottom: theme.spacing(2),
    '& label': {
      flexWrap: 'nowrap'
    }
  }),
  marginAround: (theme) => ({
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5)
  }),
  marginTop: (theme) => ({
    marginTop: theme.spacing(2)
  }),
  marginBottom: (theme) => ({
    marginBottom: theme.spacing(4)
  }),
  testimonial2: (theme) => ({
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3)
  }),
  smallPaper: (theme) => ({
    minHeight: '0px !important',
    paddingTop: '0px !important',
    paddingBottom: '0px !important'
  }),
  rechargesCtr: (theme) => ({
    // old code references theme.squareplan.window.width?
    // if so, do:
    // ...theme.squareplan.window.width,
    margin: '0 auto',
    '& a:hover': {
      textDecoration: 'none'
    }
  }),
  gridPaper: (theme) => ({
    // from old code
    borderRadius: 0,
    margin: '0 auto',
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
    marginBottom: theme.spacing(3),
    minHeight: 200,
    paddingBottom: 0,
    '& h2': {
      fontSize: '2rem',
      color: theme.palette.primary.main,
      paddingBottom: 0
    }
  }),
  hiddenSpace: (theme) => ({
    color: '#fff !important',
    pointerEvents: 'none',
    height: theme.spacing(2.5)
  }),
  featuresList: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      paddingBottom: theme.spacing(2),
      backgroundColor: 'transparent',
      backgroundImage:
        'linear-gradient(180deg, rgba(234,234,234,0.23) 0%, #ffffff 100%)'
    }
  }),
  featureHeader: (theme) => ({
    paddingTop: theme.spacing(4),
    width: '100%',
    height: 200,
    borderRight: `1px solid ${theme.palette.border.color}`,
    [theme.breakpoints.down('xs')]: {
      borderBottom: 0,
      borderRight: 0,
      height: 'auto'
    }
  }),
  gridCell: (theme) => ({
    display: 'flex',
    maxHeight: 50,
    minHeight: 50,
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    justifyContent: 'center',
    alignItems: 'center',
    borderRight: `1px solid ${theme.palette.border.color}`,
    '&.bottom': {
      borderBottom: 0
    },
    [theme.breakpoints.down('xs')]: {
      borderBottom: 0,
      borderRight: 0,
      margin: `${theme.spacing(1)}px 0px`,
      maxHeight: 'auto',
      minHeight: 'auto'
    }
  }),
  emphasis: (theme) => ({
    fontSize: '1.2rem !important',
    fontWeight: 700,
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
    height: `${theme.spacing(8)}px !important`,
    maxHeight: `${theme.spacing(8)}px !important`,
    minHeight: `${theme.spacing(8)}px !important`
  }),
  emphasisDescr: (theme) => ({
    fontWeight: 600,
    fontSize: '1.2rem !important',
    paddingTop: `${theme.spacing(4)}px !important`,
    paddingBottom: theme.spacing(2),
    height: `${theme.spacing(8)}px !important`,
    maxHeight: `${theme.spacing(8)}px !important`,
    minHeight: `${theme.spacing(8)}px !important`
  }),
  featureDesc: (theme) => ({
    padding: `0px ${theme.spacing(2)}px`,
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
    height: theme.spacing(6),
    maxHeight: theme.spacing(6),
    minHeight: theme.spacing(6),
    fontSize: '0.9rem',
    textAlign: 'left',
    justifyContent: 'left',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      justifyContent: 'center',
      marginTop: theme.spacing(2.5),
      fontSize: theme.spacing(3.25),
      paddingTop: 0
    }
  }),
  featureItem: (theme) => ({
    height: theme.spacing(6),
    maxHeight: theme.spacing(6),
    minHeight: theme.spacing(6),
    fontSize: '0.9rem',
    textAlign: 'center',
    '& pre': theme.typography.pre
  }),
  checkIcon: (theme) => ({
    color: theme.palette.primary.main,
    fontSize: '1.1rem'
  }),
  buy: (theme) => ({
    marginTop: theme.spacing(2)
  }),
  topBuy: (theme) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0),
    borderRadius: theme.spacing(3),
    maxWidth: '90%',
    fontSize: '0.8rem',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(1.75)
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(1.25),
      fontSize: '0.8rem'
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1)
    }
  }),
  mobileOnlyPricingGridContainer: (theme) => ({
    // old code references theme.squareplan.window.width? can do:
    // ...theme.squareplan.window.width,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  }),
  mobileOnlyGridPaper: (theme, injectedStyles) => ({
    margin: '0 auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: `calc(${100 / (injectedStyles?.plansNb || 1)}%)`,
    marginBottom: 50,
    minHeight: 200,
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      width: 'auto'
    },
    '& h2': {
      fontSize: '3rem',
      fontWeight: 600,
      color: theme.palette.primary.main,
      paddingBottom: 0
    },
    '& .discountedPrice h3, & h3': {
      fontSize: '1rem',
      fontWeight: 600,
      marginBottom: 0
    },
    '& .discountedPrice h4': {
      fontSize: '0.9rem',
      fontWeight: 400,
      marginTop: 0,
      color: theme.palette.text.disabled
    }
  }),
  mobileOnlyGridCell: (theme) => ({
    display: 'flex',
    padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
    justifyContent: 'flex-start',
    alignItems: 'center',
    '&.bottom': {
      borderBottom: 0,
      fontSize: theme.spacing(4)
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
      justifyContent: 'left',
      textAlign: 'left',
      borderBottom: 0,
      borderRight: 0,
      margin: `${theme.spacing(1)}px 0px`,
      maxHeight: 'auto',
      minHeight: 'auto',
      fontSize: theme.spacing(2.5)
    }
  }),
  mobileOnlyFeature: (theme) => ({
    marginLeft: theme.spacing(3),
    fontSize: '1rem'
  }),
  mobileOnlyFeatureHeader: (theme) => ({
    paddingTop: theme.spacing(4),
    width: '100%',
    height: 'auto',
    marginBottom: theme.spacing(0),
    [theme.breakpoints.down('xs')]: {
      borderBottom: 0,
      borderRight: 0,
      height: 'auto'
    }
  }),
  bottomText: (theme) => ({
    textAlign: 'center',
    '& p': {
      margin: 0,
      lineHeight: 1.5
    },
    marginBottom: theme.spacing(4)
  }),
  topUpTable: (theme) => ({
    width: '50%'
  }),
  planTitle: (theme) => ({
    fontSize: '1.5rem !important',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main
  }),
  ctaCaption: (theme) => ({
    color: '#7A7A7A',
    fontSize: '0.9rem',
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(0.5)
    }
  }),
  planPrice: (theme) => ({
    fontSize: '1.2rem',
    fontWeight: 600
  }),
  striked: (theme) => ({
    textDecoration: 'line-through',
    fontSize: '0.9rem',
    fontWeight: 400,
    marginTop: 0,
    color: theme.palette.text.disabled
  }),
  rechargesTitleCtr: (theme) => ({
    textAlign: 'center',
    marginBottom: theme.spacing(4)
  }),
  creditItemCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: -theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      marginBottom: -theme.spacing(2)
    }
  }),
  itemBodyLeft: (theme) => ({
    flexGrow: 1
  }),
  itemBodyRight: (theme) => ({}),
  itemBodyCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }),
  itemFooter: (theme) => ({
    flexGrow: 1,
    borderBottom: '3px dashed hsl(0,0%,50%)'
  }),
  topupCredits: (theme) => ({
    fontSize: '1.5rem',
    paddingBottom: theme.spacing(0),
    fontWeight: 600
  }),
  topupCaption: (theme) => ({
    fontSize: '0.9rem',
    fontWeight: 500,
    color: 'hsl(0,0%,50%)',
    paddingBottom: theme.spacing(0)
  }),
  topupPrice: (theme) => ({
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    borderRadius: 24,
    position: 'relative',
    top: '8px',
    padding: '2px 16px',
    fontWeight: 600,
    fontSize: '1rem'
  }),
  planPricePAYG: (theme) => ({
    marginTop: 4,
    fontWeight: 600,
    fontSize: '1rem'
  }),
  newCenteredSectionCtr: (theme) => ({
    margin: '0 auto',
    textAlign: 'center'
  }),
  topMarginSpacing2: (theme) => ({
    marginTop: theme.spacing(2)
  }),
  topMarginSpacing4: (theme) => ({
    marginTop: theme.spacing(4)
  }),
  topMarginSpacing6: (theme) => ({
    marginTop: theme.spacing(6)
  }),
  bottomMarginSpacing2: (theme) => ({
    marginBottom: theme.spacing(2)
  }),
  topupSignupBtn: (theme) => ({
    margin: '0 auto',
    borderRadius: theme.spacing(3),
    '& *': {
      fontSize: '1rem'
    }
  }),
  smallBody1: (theme) => ({
    fontSize: '0.9rem'
  }),
  desktopPlanContainer: (theme) => ({
    width: 'auto'
  }),
  leftColItem: (theme) => ({
    width: 190
  }),
  planColItem: (theme) => ({
    width: 150
  }),
  upgradeFeatureHeader: (theme) => ({
    paddingTop: theme.spacing(4),
    width: '100%',
    height: 120,
    padding: `0px ${theme.spacing(2)}px`,
    borderRight: `1px solid ${theme.palette.border.color}`,
    [theme.breakpoints.down('xs')]: {
      borderBottom: 0,
      borderRight: 0,
      height: 'auto'
    }
  }),
  upgradeFeatureHeaderRight: (theme) => ({
    paddingTop: theme.spacing(4),
    width: '100%',
    height: 120,
    [theme.breakpoints.down('xs')]: {
      borderBottom: 0,
      borderRight: 0,
      height: 'auto'
    }
  }),
  upgradeFeatureItem: (theme) => ({
    fontSize: '0.9rem',
    textAlign: 'center',
    borderRight: 0,
    '& pre': theme.typography.pre
  })
};

export default contentfulPricingSectionStyles;